
module.exports = function getResource(label, vars = []) {
    const resources = {
        viewExclusiveOffer: `Découvrez une offre exclusive ${vars[0]} pour vous`,
        viewExclusiveOffers: `Découvrez des offres exclusives ${vars[0]} pour vous`
    };

    return resources[label];
};
